var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.member
    ? _c(
        "tr",
        { staticClass: "md-table-row" },
        [
          _c("td", { staticClass: "md-table-cell" }, [
            _c("div", { staticClass: "md-table-cell-container" }, [
              _c(
                "span",
                {
                  staticClass: "display-link",
                  on: {
                    click: function($event) {
                      return _vm.goToProfile()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.displayName(_vm.member)))]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "display-link",
                      on: {
                        click: function($event) {
                          return _vm.goToProfile()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.member.emails[0]))]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.settings
            ? [
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "approvals"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.approvals,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "approvals", $$v)
                          },
                          expression: "settings.approvals"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "escalate"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.escalate,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "escalate", $$v)
                          },
                          expression: "settings.escalate"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "reports"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.reports,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "reports", $$v)
                          },
                          expression: "settings.reports"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "members"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.members,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "members", $$v)
                          },
                          expression: "settings.members"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "requests"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.requests,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "requests", $$v)
                          },
                          expression: "settings.requests"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "responses"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.responses,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "responses", $$v)
                          },
                          expression: "settings.responses"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "donor"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.donor,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "donor", $$v)
                          },
                          expression: "settings.donor"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "feedback"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.feedback,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "feedback", $$v)
                          },
                          expression: "settings.feedback"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "referee"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.referee,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "referee", $$v)
                          },
                          expression: "settings.referee"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "unsubscribe"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.unsubscribe,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "unsubscribe", $$v)
                          },
                          expression: "settings.unsubscribe"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "profileupdate"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.profileupdate,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "profileupdate", $$v)
                          },
                          expression: "settings.profileupdate"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "md-table-cell" }, [
                  _c(
                    "div",
                    { staticClass: "md-table-cell-container text-center" },
                    [
                      _c("md-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.updateAdminSettings(
                              _vm.settings._id,
                              "nofollowup"
                            )
                          }
                        },
                        model: {
                          value: _vm.settings.nofollowup,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "nofollowup", $$v)
                          },
                          expression: "settings.nofollowup"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$lodash.has(_vm.member.requestReceived, "lastRequestReceived") &&
          !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("momentDate")(
                        _vm.member.requestReceived.lastRequestReceived
                      )
                    )
                  )
                ])
              ])
            : !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v("---")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$lodash.has(_vm.member.response, "lastResponse") && !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("momentDate")(_vm.member.response.lastResponse)
                    )
                  )
                ])
              ])
            : !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v("---")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$lodash.has(_vm.member, "lastFeedback") && !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v(_vm._s(_vm._f("momentDate")(_vm.member.lastFeedback)))
                ])
              ])
            : !_vm.settings
            ? _c("td", { staticClass: "md-table-cell" }, [
                _c("div", { staticClass: "md-table-cell-container" }, [
                  _vm._v("---")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("td", { staticClass: "md-table-cell" }, [
            (_vm.dataType === "advisor" &&
              _vm.member.community == _vm.$route.params.community_id) ||
            _vm.dataType === "administrator"
              ? _c(
                  "div",
                  { staticClass: "md-table-cell-container" },
                  [
                    _c("md-dialog-confirm", {
                      attrs: {
                        "md-active": _vm.active,
                        "md-title": "Delete Confirmation",
                        "md-content": _vm.setContent
                      },
                      on: {
                        "update:mdActive": function($event) {
                          _vm.active = $event
                        },
                        "update:md-active": function($event) {
                          _vm.active = $event
                        },
                        "md-confirm": _vm.removeAdmin
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "md-remove",
                        on: {
                          click: function($event) {
                            _vm.active = true
                          }
                        }
                      },
                      [_vm._v("Remove")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53885be6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53885be6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminList.vue
// module id = null
// module chunks = 